import React from "react";
import LogOutButton from "../LoginForm/LogOutButton/LogOut";
import { Paper } from "@material-ui/core";

export default function Footer({ userData }) {
	const style = {
		padding: "0.5em",
		position: "fixed",
		bottom: "0",
		right: "0",
		textAlign: "center",
		color: "#fff",
	};
	return (
		<footer style={style}>
			<Paper style={{ padding: "0.25em 1.25em", backgroundColor: "#ffffff30" }}>
				<LogOutButton />
			</Paper>
		</footer>
	);
}
